import Select from 'react-select';
import { setDbSrc } from '../../redux/rulesSlice';
import { useDispatch, useSelector } from 'react-redux';

export default function DropDownDBSrc() {
    const dbSrc = useSelector(state => state.rules.dbSrc);
    const dispatch = useDispatch();
    const options = [
        { value: 'prd', label: 'PROD' },
        { value: 'dev', label: 'DEV'}
    ];

    const handleDBSrcChange = (src) => {
    dispatch(setDbSrc(src));
    };

    return (
        <div className='flex items-center gap-4 flex-nowrap'>
            <span>DB:</span>
            <span>
                <Select options={options}
                    defaultValue={options.find(x => x.value === dbSrc)}
                    select onChange={(e) => handleDBSrcChange(e.value)}
                />
            </span>
        </div>
    )
}